// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@adl/XDL/PreStyle/typography";
import { xBaseTheme } from "@adl/XDL/types";
import { color, ellipsis } from "@adl/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        border: "rounded",
        sizeVariant: "default",
        backgroundColor: "common.white",
        labelProps: {
            mergeCss: true,
            size: 12,
            transform: "capitalize",
            weight: 400,
            color: "text",
            css: css`
                min-height: initial;
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        errorProps: {
            mergeCss: true,
            size: 12,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
            `,
        },
        cssOverrides: {
            descriptionWrapper: css`
                &&&& {
                    margin-top: 10px;
                }
            `,
            formInputWrapper: css`
                input,
                textarea,
                select {
                    &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                        ${ellipsis(1)}
                        box-shadow: inset 0 1px 0 0 ${color("common.ui8", 0.1)};
                        text-overflow: ellipsis;
                        &::placeholder,
                        &::-webkit-input-placeholder {
                            font-size: 14px;
                            font-style: italic;
                            letter-spacing: 0;
                            line-height: 19px !important;
                            max-width: 100%;
                            color: ${color("common.ui6")};
                            font-family: ${fontConfig.fontFamily};
                        }
                    }
                }
                &:disabled {
                    border: 1px solid ${color('common.ui6')};
                    background: ${color('common.ui14')};
                    color: ${color('text.main')};
                }
            `,
            inputSelect: css`
                letter-spacing: 0;
                line-height: 16px;
                box-shadow: inset 0 1px 0 0 ${color("common.ui8", 0.1)};
                &:focus,
                &:hover {
                    border: 1px solid ${color("common.ui1")};
                }
                &:focus {
                    border: 1px solid ${color("common.ui2")};
                }
                &:disabled {
                    border: 1px solid ${color('common.ui6')};
                    background: ${color('common.ui14')};
                    color: ${color('text.main')};
                }
            `,
        },
    },
} as xBaseTheme["formField"];
